import {
  deleteAppDeviceId,
  getAppDeviceId,
  readAppDeviceId,
} from "./idempotency-key";

const FORMS_API = "/.netlify/functions/forms-api";

/**
 * Submit a lead to the CivSav dashboard via Netlify function.
 * @param {object} options
 * @param {string} options.formId
 * @param {string} options.formName - cookie key for idempotency
 * @param {"completed"|"abandoned"} [options.status]
 * @param {string} [options.name]
 * @param {string} [options.email]
 * @param {string} [options.phone]
 * @param {Record<string, unknown>} [options.data]
 * @param {boolean} [options.keepalive]
 * @param {boolean} [options.createIdempotencyKey] - false for abandon-only reads
 */
export async function submitLead({
  formId,
  formName,
  status = "completed",
  name,
  email,
  phone,
  data = {},
  keepalive = false,
  createIdempotencyKey = true,
}) {
  if (!formId) {
    throw new Error(
      "Missing dashboard formId. Add it in src/content/formIds.js"
    );
  }

  const idemKey = createIdempotencyKey
    ? readAppDeviceId(formName) || getAppDeviceId(formName)
    : readAppDeviceId(formName);

  const payload = {
    ...(name ? { name } : {}),
    ...(email ? { email } : {}),
    ...(phone ? { phone } : {}),
    source_url: typeof window !== "undefined" ? window.location.href : "",
    status,
    data: {
      website:
        typeof window !== "undefined" ? window.location.origin : undefined,
      date: new Date().toUTCString(),
      ...data,
    },
    formId,
  };

  const response = await fetch(FORMS_API, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      ...(idemKey ? { "Idempotency-Key": idemKey } : {}),
    },
    keepalive,
  });

  if (!response.ok) {
    const text = await response.text().catch(() => "");
    console.error("Lead submit failed", {
      status: response.status,
      body: text,
      formId,
      statusField: status,
    });
    throw new Error(text || `Form submission failed (${response.status})`);
  }

  if (status === "completed") {
    deleteAppDeviceId(formName);
  }

  return response;
}
